<template>
  <section class="section">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-half">
          <div class="box">
            <h1 class="title">Change Password</h1>

            <form-wizard
              :metadata="RegisterMetaData"
              :fields="RegisterFields"
              @submit="onSubmit"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Library from 'library'
import axios from 'axios'

export default {
  name: 'Settings',

  data () {
    return {
      data: {}
    }
  },

  methods: {
    async onSubmit (data) {
      const loader = this.$loading.open()
      try {
        const User = this.$store.state.auth.user

        await axios.patch(`https://plasticcollectionapiadmin.azurewebsites.net/api/Accounts/${User.id}/Password`, {
          userName: User.userName,
          password: data.oldPassword,
          newPassword: data.password
        }, {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
      } catch (e) {
        console.error(e)
        if (e && e.response && e.response.status === 401) {
          this.$handleError('Your old password was incorrect.')
        } else {
          console.error(e)
          this.$handleError('There was an error resetting your password', e.response.data)
        }
      } finally {
        loader.close()
      }
    }
  },

  computed: {
    RegisterMetaData () {
      return {
        entityName: 'Register',
        properties: [
          {
            propertyName: 'oldPassword',
            inputType: 'Password',
            defaultValue: null,
            isCollection: false,
            typeName: 'String',
            isReadOnly: false,
            isForeignKey: false,
            isPrimaryKey: false,
            isDependentType: false,
            properties: null,
            options: {
              allowsNulls: false,
              isRequired: true,
              maximum: 255,
              minimum: 8,
              stepSize: null,
              possibleValues: null
            }
          },
          {
            propertyName: 'password',
            inputType: 'Password',
            defaultValue: null,
            isCollection: false,
            typeName: 'String',
            isReadOnly: false,
            isForeignKey: false,
            isPrimaryKey: false,
            isDependentType: false,
            properties: null,
            options: {
              allowsNulls: false,
              isRequired: true,
              maximum: 255,
              minimum: 8,
              stepSize: null,
              possibleValues: null
            }
          },
          {
            propertyName: 'confirmPassword',
            inputType: 'Password',
            defaultValue: null,
            isCollection: false,
            typeName: 'String',
            isReadOnly: false,
            isForeignKey: false,
            isPrimaryKey: false,
            isDependentType: false,
            properties: null,
            options: {
              allowsNulls: false,
              isRequired: true,
              maximum: 255,
              minimum: 8,
              stepSize: null,
              possibleValues: null
            }
          }
        ]
      }
    },

    RegisterFields () {
      return this.RegisterMetaData.properties.map(item => item.propertyName)
    }
  },

  components: {
    FormWizard: Library.Components.FormWizard
  }
}
</script>
